import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Loader2, CreditCard, XCircle, CheckCircle2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const orderId = params.get('order_id');
  const [state, setState] = useState('loading');
  const [booking, setBooking] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!orderId) { setState('error'); return; }
    (async () => {
      try {
        const { data } = await axios.get(`${API}/bookings/${orderId}`);
        setBooking(data);
        if (data.payment_status === 'PAID') setState('paid');
        else if (!data.cashfree_payment_session_id) setState('no-session');
        else setState('ready');
      } catch (e) {
        setError(e?.response?.data?.detail || 'Booking not found');
        setState('error');
      }
    })();
  }, [orderId]);

  const startCheckout = () => {
    if (!window.Cashfree) { setError('Payment gateway loading...'); return; }
    const cashfree = window.Cashfree({ mode: booking.cashfree_mode || 'sandbox' });
    cashfree.checkout({
      paymentSessionId: booking.cashfree_payment_session_id,
      redirectTarget: '_self',
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <Card className="card-dark w-full max-w-md p-8 text-center">
        {state === 'loading' && (
          <>
            <Loader2 className="w-12 h-12 text-pink-400 mx-auto animate-spin" />
            <p className="mt-4 text-gray-400">Loading...</p>
          </>
        )}
        {state === 'ready' && booking && (
          <>
            <div className="mx-auto w-14 h-14 rounded-full flex items-center justify-center" style={{background:'linear-gradient(135deg,#a855f7,#ec4899)'}}>
              <CreditCard className="w-7 h-7 text-white" />
            </div>
            <h1 className="mt-4 text-2xl font-extrabold gradient-text">પેમેન્ટ પૂરું કરો</h1>
            <p className="mt-1 text-sm text-gray-400">One Stop Carz</p>
            <div className="mt-5 rounded-xl border border-purple-900/60 bg-[#14141c] p-4 text-sm text-gray-300 text-left space-y-1.5">
              <div className="flex justify-between"><span className="text-gray-400">Booking ID</span><span className="text-white font-mono text-xs">{booking.id}</span></div>
              <div className="flex justify-between"><span className="text-gray-400">Name</span><span className="text-white">{booking.name}</span></div>
              <div className="flex justify-between"><span className="text-gray-400">પેકેજ</span><span className="text-white">{booking.package_name}</span></div>
              <div className="flex justify-between"><span className="text-gray-400">તારીખ</span><span className="text-white">{new Date(booking.booking_date).toLocaleDateString('en-IN')}</span></div>
              <div className="flex justify-between pt-2 border-t border-purple-900/40"><span className="text-gray-400">ચુકવવાની રકમ</span><span className="text-white font-bold text-lg">₹{booking.amount}</span></div>
            </div>
            <Button onClick={startCheckout} className="gradient-btn rounded-full h-12 w-full mt-6 font-semibold">
              <CreditCard className="w-5 h-5 mr-2" /> Pay ₹{booking.amount} Now
            </Button>
          </>
        )}
        {state === 'paid' && (
          <>
            <CheckCircle2 className="w-14 h-14 text-green-400 mx-auto" />
            <h1 className="mt-4 text-2xl font-extrabold text-white">પહેલેથી કન્ફર્મ!</h1>
            <p className="mt-2 text-gray-400 text-sm">Booking ID: <span className="font-mono">{booking?.id}</span></p>
            <Button onClick={() => navigate(`/booking/return?order_id=${orderId}`)} className="gradient-btn rounded-full h-11 px-6 mt-6 font-semibold">View Details</Button>
          </>
        )}
        {(state === 'error' || state === 'no-session') && (
          <>
            <XCircle className="w-14 h-14 text-red-400 mx-auto" />
            <h1 className="mt-4 text-2xl font-extrabold text-white">Link અમાન્ય</h1>
            <p className="mt-2 text-gray-400 text-sm">{error || 'Payment session not available. Contact +91 84606 92482'}</p>
            <Button onClick={() => navigate('/')} className="gradient-btn rounded-full h-11 px-6 mt-6 font-semibold">Home</Button>
          </>
        )}
      </Card>
    </div>
  );
}
